import { type PropsWithChildren, useCallback } from 'react';
import { useSymbolStore } from '@/stores/symbol';
import type { SymbolType } from './symbol.type';

type Props = {
  slug: SymbolType;
};

const SymbolContainer = ({ slug, children }: PropsWithChildren<Props>) => {
  const setScrollObserver = useSymbolStore((s) => s.setScrollObserver);
  const disconnectScrollObserver = useSymbolStore((s) => s.disconnectScrollObserver);

  const bindRef = useCallback((ref: HTMLDivElement | null) => {
    if (ref) {
      setScrollObserver(slug, ref);
    } else {
      disconnectScrollObserver(slug);
    }
  }, []);

  return (
    <div
      ref={bindRef}
      className='no-scrollbar h-full overflow-y-auto overscroll-contain px-1'>
      {children}
    </div>
  );
};

export default SymbolContainer;
